import { Query, } from "../Query";
import { RpcDispatcher } from "./RpcDispatcher";
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function TokenTrackerRpcMixin(base) {
    return class TokenTrackerRpcInterface extends base {
        async getNep17Transfers(accountIdentifier, startTime, endTime) {
            return this.execute(Query.getNep17Transfers(accountIdentifier, startTime, endTime));
        }
        async getNep17Balances(accountIdentifier) {
            return this.execute(Query.getNep17Balances(accountIdentifier));
        }
        async getNep11Transfers(accountIdentifier, startTime, endTime) {
            return this.execute(Query.getNep11Transfers(accountIdentifier, startTime, endTime));
        }
        async getNep11Balances(accountIdentifier) {
            return this.execute(Query.getNep11Balances(accountIdentifier));
        }
    };
}
export class TokenTrackerRpcClient extends TokenTrackerRpcMixin(RpcDispatcher) {
    get [Symbol.toStringTag]() {
        return `TokenTrackerRpcClient(${this.url})`;
    }
}
//# sourceMappingURL=TokenTrackerRpcClient.js.map